import MidiAction from './MidiAction.js';
import {SEQUENCE_ROLL} from 'constants/midi-actions.js';

class SequenceRollAction extends MidiAction {
    constructor(sequencerEngine) {
        super(SEQUENCE_ROLL);
        this.sequencerEngine = sequencerEngine;
    }

    execute(value) {
        let roll = value > 127 / 2.0;

        console.log('excecuting sequence roll action');
        this.sequencerEngine.sequenceRolling = roll;
    }
}

export default SequenceRollAction;
